import { Pipe, PipeTransform } from '@angular/core';
import { DatePipe } from '@angular/common';

declare const DATE_FMT = 'dd/MMM/yyyy';
declare const DATE_TIME_FMT = 'dd/MM/yyyy hh:mm:ss';

@Pipe({
  name: 'myDateTransformer',
  pure: false
})
export class DateTransformerPipe extends DatePipe implements PipeTransform {

  transform(value: any, args?: any): any {
    if (value) {
      try {
        return super.transform(value, 'dd/MM/yyyy');
      } catch (e) {
        return 'FAIL';
      }
    }
  }
}
